import type { HotelSearchResultsData } from 'tripPlanner/api/types'
import type { OfferClickSearchParams } from 'tripPlanner/assistant/contexts/ChatMessageActionsContext'
import { convertDateRangesToMonthString, mapFlexibleNightsToDurationRange } from 'lib/search/flexibleDateUtils'

export function hotelSearchResultParams({ searchDates, occupancy }: HotelSearchResultsData): OfferClickSearchParams {
  const rooms = occupancy?.map(room => ({
    adults: room.adults,
    children: room.childrenAge?.length ?? 0,
    childrenAge: room.childrenAge,
    infants: 0,
  }))
  if (searchDates?.type === 'specific') {
    return { rooms, checkIn: searchDates.checkIn, checkOut: searchDates.checkOut }
  }
  if (searchDates?.type === 'flexible') {
    return {
      rooms,
      flexibleMonths: convertDateRangesToMonthString(searchDates.dateRanges),
      flexibleNights: mapFlexibleNightsToDurationRange(searchDates.numberOfNights),
    }
  }
  return { rooms }
}
